import {useState} from 'react';
import {v4} from 'uuid';

export const useId = () => {
  const [id] = useState(() => v4());

  return id;
};
